/*
 * Durnev Compare Slider — drag the handle horizontally to reveal
 * before/after images. No dependencies, supports mouse + touch.
 */
(function () {
  'use strict';

  function init(container) {
    if (!container || container.dataset.compareInit === '1') return;
    container.dataset.compareInit = '1';

    var handle = container.querySelector('.dc-compare__handle');
    if (!handle) return;

    function setPos(clientX) {
      var rect = container.getBoundingClientRect();
      var x = Math.max(0, Math.min(rect.width, clientX - rect.left));
      var pct = (x / rect.width) * 100;
      container.style.setProperty('--pos', pct.toFixed(2) + '%');
    }

    var dragging = false;

    function getClientX(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
      return e.clientX;
    }

    function onDown(e) {
      dragging = true;
      container.classList.add('is-dragging');
      setPos(getClientX(e));
      if (e.cancelable) e.preventDefault();
    }
    function onMove(e) {
      if (!dragging) return;
      setPos(getClientX(e));
    }
    function onUp() {
      dragging = false;
      container.classList.remove('is-dragging');
    }

    container.addEventListener('mousedown', onDown);
    handle.addEventListener('mousedown', onDown);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);

    container.addEventListener('touchstart', onDown, { passive: false });
    handle.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('touchend', onUp);
    document.addEventListener('touchcancel', onUp);

    // Keyboard support on the handle
    handle.setAttribute('tabindex', '0');
    handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(getComputedStyle(container).getPropertyValue('--pos')) || 50;
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') { container.style.setProperty('--pos', Math.max(0, cur - step) + '%'); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { container.style.setProperty('--pos', Math.min(100, cur + step) + '%'); e.preventDefault(); }
      else if (e.key === 'Home') { container.style.setProperty('--pos', '0%'); e.preventDefault(); }
      else if (e.key === 'End') { container.style.setProperty('--pos', '100%'); e.preventDefault(); }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-compare]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Handle Shopify theme editor re-renders
  document.addEventListener('shopify:section:load', initAll);
})();
